import React, { useState } from 'react';
import { css } from '@emotion/css';
import classnames from 'classnames';

import type { VFC } from 'react';

import sakeList from '../../csv/list.csv';

const mq768 = '@media (min-width: 768px)';

const styles = {
  list: css({

    [mq768]: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    },
  }),

  item: css({
    margin: '0 0 20px',
    borderBottom: '1px solid #707070',
    padding: '0 0 20px',

    [mq768]: {
      width: 'calc(100% / 3 - ((20px * 2) / 3))',
    },
  }),

  title: css({
    fontSize: '1.5rem',
    margin: '0 0 5px',
  }),

  address: css({
    fontSize: '1.5rem',
    display: 'block',
  }),

  tel: css({
    fontSize: '1.5rem',
    display: 'block',
  }),
};

const List: VFC = () => {
  return (
    <>
      <ul className={styles.list}>
        {
          sakeList.map(({ title, address, tel }, index) => (
            <li className={styles.item} key={index}>
              <h3 className={styles.title}>{title}</h3>
              {
                address ? (
                  <p className={styles.address}>{address}</p>
                ) : null
              }
              {
                tel ? (
                  <p className={styles.tel}>{tel}</p>
                ) : null
              }
            </li>
          ))
        }

      </ul>
    </>
  );
};

export default List;
